export const generateUniqueId = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const randomValues = crypto.getRandomValues(new Uint8Array(6));

  return Array.from(randomValues, (value) => characters.charAt(value % characters.length)).join('');
};
